import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import CategoryWithTitles from '../../components/category-with-titles/category-with-titles.component';
import PageHeader from '../../components/page-header/page-header.component';
import ProductCard from '../../components/product-card/product-card.component';
import { CategoriesContext } from '../../contexts/categories.context';
import NotFound from '../not-found/not-found.page';
import { categoriesText } from './categories-text';
import '../../styles/product-grid.styles.scss';
import './category.styles.scss';

const Category = () => {
  const { category } = useParams();
  const { categoriesMap } = useContext(CategoriesContext);

  // categoriesMap vaut SHOP_DATA : la donnée est synchrone, on la dérive donc au rendu.
  // (Avec un state + useEffect, le premier rendu se ferait sur une catégorie vide.)
  const currentCategory = categoriesMap.find(
    (cat) => category.toLowerCase() === cat.title.toLowerCase()
  );

  // `:category` matche n'importe quelle chaîne : /shop/nimportequoi arrive ici et doit
  // donner une vraie page « introuvable », pas un gabarit vide titré avec l'URL.
  if (!currentCategory) {
    return <NotFound />;
  }

  // On repart du titre du catalogue, jamais du segment d'URL : le match ci-dessus étant
  // insensible à la casse, /shop/FLEURS doit donner la même page que /shop/fleurs.
  const { title, items: products, imageFamily: image } = currentCategory;

  // Certaines catégories sont découpées en sous-familles (fleurs : indoor / greenhouse),
  // d'autres s'affichent d'une seule traite (hasch).
  const hasSubTitles = products.some((product) => product.categoryTitle);

  return (
    <div className="category-page">
      <section className="category-intro">
        <div>
          <PageHeader overline="Boutique" title={title} />
          {categoriesText[title].map((paragraph) => (
            <p className="category-lead" key={paragraph}>
              {paragraph}
            </p>
          ))}
        </div>

        <div className="category-intro-media">
          <img src={image} alt={`Culture ${title} Lacana`} />
        </div>
      </section>

      {hasSubTitles ? (
        <CategoryWithTitles products={products} />
      ) : (
        <div className="product-grid">
          {products.map((product) => (
            <ProductCard key={product?.id} product={product} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Category;
